import type { AssetDuplicateButtonProps } from "./asset-duplicate-button.type";

import { ModelDuplicateButton } from "@/modules/model-duplicate";

import { AssetDuplicateForm } from "../asset-duplicate-form";

const AssetDuplicateButton = ({
  asset,
  ...buttonProps
}: AssetDuplicateButtonProps) => {
  return (
    <ModelDuplicateButton
      {...buttonProps}
      modelKey="asset"
      form={<AssetDuplicateForm asset={asset} />}
    />
  );
};

export default AssetDuplicateButton;
